import Vue from 'vue';
import VueI18n from 'vue-i18n';
import qs from 'qs'

import zh_CN from './zh_CN';
import en_US from './en_US';
import storage from '@/utils/storage'

Vue.use(VueI18n);

const locationSearch = qs.parse(location.search.length>0?location.search.substring(1):"")
const LANG = locationSearch.lang

let code = storage.local.get('lang')
code = (LANG || code) === 'en_US' ? 'en_US' : 'zh_CN'

const i18n = new VueI18n({
  locale: code, // default locale
  fallbackLocale: code,
  messages: {
    zh_CN,
    en_US,
  },
});

export default i18n;
